import React from "react";
import type { AnalyticsClient } from "./analyticsClient";
import { AnalyticsContext } from "./AnalyticsProvider";

/**
 * The app-facing analytics entry point.
 *
 * `const analytics = useAnalytics();`
 * `analytics.track("BCC Fulfillment / Batch Created", { ... })`
 */
export const useAnalytics = (): AnalyticsClient => React.useContext(AnalyticsContext);
